import React from 'react'

import {
  type CpnErrorWithResponse,
  formatCpnErrorMessage,
} from '@/utils/errorFormatting'

type QuoteStatusProps = {
  isQuoteLoading: boolean
  quoteError?: Error | null
  exchangeRate: number
  sendCurrency: string
  receiveCurrency: string
}

const QuoteStatus: React.FC<QuoteStatusProps> = ({
  isQuoteLoading,
  quoteError,
  exchangeRate,
  sendCurrency,
  receiveCurrency,
}) => {
  const errWithResponse = quoteError
    ? (quoteError as CpnErrorWithResponse)
    : null

  const formattedError = quoteError
    ? formatCpnErrorMessage({
        errorMessage: quoteError.message,
        limits: errWithResponse?.response?.data?.limits,
      })
    : ''
  const isAmountLimitError =
    quoteError &&
    errWithResponse?.response?.data?.code === 'AMOUNT_OUT_OF_RANGE'

  return (
    <div className="flex items-center space-x-2">
      {isQuoteLoading ? (
        <span className="text-sm font-medium dark:text-gray-300">
          Fetching rate...
        </span>
      ) : quoteError && !isAmountLimitError ? (
        <div className="flex flex-col items-center space-y-1 max-w-xs">
          <span className="text-xs text-red-500 dark:text-red-400 text-center leading-tight">
            {formattedError}
          </span>
        </div>
      ) : (
        <span className="text-sm font-medium dark:text-gray-300">
          1 {sendCurrency} = {exchangeRate.toFixed(4)} {receiveCurrency}
        </span>
      )}
    </div>
  )
}

export default QuoteStatus
